// authStore.js
import { defineStore } from "pinia";
import api from "@/services/api";

export const useAuthStore = defineStore("authStore", {
  state: () => ({
    isAuthenticated: false,
    user: {
      name: "", // Nombre del usuario
      photo: null, // URL pre-firmada
      empresa: null, // ID de la empresa del usuario
    },
  }),
  actions: {
    async login(username, password) {
      try {
        const { status, data } = await api.login(username, password);
        if (status === 200) {
          this.isAuthenticated = true;
          this.user = {
            name: data.user.username, // Asignar el nombre de usuario
            photo: data.user.foto_perfil, // URL pre-firmada de la foto de perfil
            empresa: data.empresa, // Asignar el ID de la empresa
          };
          await this.fetchProfileImage();
        } else {
          alert("Usuario o contraseña incorrectos");
        }
      } catch (error) {
        console.error("Error al intentar iniciar sesión:", error);
      }
    },
    async logout() {
      try {
        const response = await api.logout();
        if (response.ok) {
          this.isAuthenticated = false;
          this.user = { name: "", photo: null };
        }
      } catch (error) {
        console.error("Error al cerrar sesión:", error);
        throw error;
      }
    },
    async fetchProfileImage() {
      try {
        const response = await api.getProfileImage();
        if (response.url) {
          this.user.photo = response.url;
        }
      } catch (error) {
        console.error("Error obteniendo la imagen de perfil:", error);
      }
    },
    updateUser(user) {
      this.user = { ...this.user, ...user };
    },
    async checkAuthentication() {
      try {
        const response = await api.validateToken();
        this.isAuthenticated = response.status === 200;
      } catch (error) {
        console.error("Error verificando la autenticación:", error);
        this.isAuthenticated = false;
      }
    },
    // Opcional: acción para refrescar los datos del usuario
    async refreshUserData() {
      try {
        const response = await api.getUser();
        if (response.user) {
          this.user = {
            name: response.user.username,
            photo: response.user.foto_perfil,
          };
          await this.fetchProfileImage();
        }
      } catch (error) {
        console.error("Error al refrescar datos del usuario:", error);
      }
    },
  },
  persist: {
    paths: ["isAuthenticated", "user"],
  },
});
